import React from "react";
import { Trophy, TrendingUp, Activity, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle, CardDescription, CardFooter } from "@/components/ui/card";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Profile() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="46" id="embedhtmlbox" ref={sectionRef} className="relative min-h-[800px] w-full overflow-hidden bg-white py-20 lg:py-32 flex items-center">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute top-[-20%] right-[-10%] h-[800px] w-[800px] rounded-full bg-secondary/10 opacity-40 blur-[120px] animate-pulse" />
        <div className="absolute bottom-[-20%] left-[-10%] h-[600px] w-[600px] rounded-full bg-primary/5 opacity-30 blur-[100px]" />
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1608256/img/noise_texture.png)] opacity-5 mix-blend-overlay" />
      </div>

      <div className="container relative z-10 mx-auto px-6">
        <div className="grid gap-12 lg:grid-cols-[1.5fr_1fr] lg:items-center">
          
          {}
          <div className={`flex flex-col gap-8 transition-all duration-1000 ease-out ${isVisible ? "translate-x-0 opacity-100" : "-translate-x-10 opacity-0"}`}>
            <div className="space-y-4">
              <h1 className="text-6xl font-extrabold tracking-tight text-primary sm:text-7xl lg:text-8xl">View Rentals</h1>
              <p className="max-w-2xl text-xl text-muted-foreground sm:text-2xl leading-relaxed">
                Expert property management in Orlando. We handle the stress of leasing and maintenance so you can focus on growth.
              </p>
            </div>

            <div className="flex flex-col gap-4 sm:flex-row">
              <Button asChild size="lg" className="h-14 px-8 text-lg font-bold bg-primary text-white hover:bg-primary/90 shadow-lg">
                <Link to="/OwnersPage">
                  Free Rental Analysis
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="h-14 px-8 text-lg border-primary/20 bg-primary/5 text-primary hover:bg-primary/10 hover:text-primary backdrop-blur-sm">
                <Link to="/RentalsPage">
                  Available Rentals
                </Link>
              </Button>
            </div>

            {}
            <div className="mt-8 flex items-center gap-6 text-sm text-muted-foreground">
              <div className="flex items-center gap-2">
                <Activity className="h-5 w-5 text-secondary" />
                <span>24/7 Portal Access</span>
              </div>
              <div className="flex items-center gap-2">
                <Trophy className="h-5 w-5 text-secondary" />
                <span>Premier Management</span>
              </div>
            </div>
          </div>

          {}
          
        </div>
      </div>
    </section>;
}